// src/constants/serviceIcons.js

import { SERVICE_TYPES } from './serviceTypes';

export const categoryIcons = {
  // Alphabetical by service type
  [SERVICE_TYPES.APPLIANCE_REPAIR]: '🔌',
  [SERVICE_TYPES.AUTO_BODY_REPAIR]: '🚗',
  [SERVICE_TYPES.BAKERY]: '🍞',
  [SERVICE_TYPES.BARBER]: '💈',
  [SERVICE_TYPES.BEAUTY_SALON]: '💇‍♀️',
  [SERVICE_TYPES.CAR_WASH_DETAILING]: '🧼',
  [SERVICE_TYPES.CARPENTER]: '🪚',
  [SERVICE_TYPES.CATERING]: '🍱',
  [SERVICE_TYPES.CHILDCARE]: '👶',
  [SERVICE_TYPES.CLEANER]: '🧹',
  [SERVICE_TYPES.COFFEE_SHOP]: '☕',
  [SERVICE_TYPES.CONSULTANT]: '💼',
  [SERVICE_TYPES.CULINARY_CLASSES]: '👨‍🍳',
  [SERVICE_TYPES.DELIVERY_SERVICE]: '📦',
  [SERVICE_TYPES.DIGITAL_MARKETING]: '📊',
  [SERVICE_TYPES.DJ_ENTERTAINMENT]: '🎧',
  [SERVICE_TYPES.ELDER_CARE]: '👴',
  [SERVICE_TYPES.ELECTRICIAN]: '⚡',
  [SERVICE_TYPES.EVENT_PLANNER]: '🎪',
  [SERVICE_TYPES.FITNESS_TRAINER]: '💪',
  [SERVICE_TYPES.FLOORING_SPECIALIST]: '🏗️',
  [SERVICE_TYPES.FOOD_CATERER]: '🍲',
  [SERVICE_TYPES.FOOD_DELIVERY]: '🚴',
  [SERVICE_TYPES.FOOD_TRUCK]: '🚚',
  [SERVICE_TYPES.GRAPHIC_DESIGNER]: '🎨',
  [SERVICE_TYPES.HAIRDRESSER]: '💇',
  [SERVICE_TYPES.HANDYMAN]: '🛠️',
  [SERVICE_TYPES.HVAC_TECHNICIAN]: '❄️',
  [SERVICE_TYPES.ICE_CREAM_PARLOR]: '🍦',
  [SERVICE_TYPES.INTERIOR_DESIGNER]: '🛋️',
  [SERVICE_TYPES.IT_SUPPORT]: '💻',
  [SERVICE_TYPES.JEWELRY_REPAIR]: '💍',
  [SERVICE_TYPES.JUICE_BAR]: '🍹',
  [SERVICE_TYPES.LANDSCAPER]: '🌿',
  [SERVICE_TYPES.LANGUAGE_INSTRUCTOR]: '🌍',
  [SERVICE_TYPES.LAUNDRY_SERVICE]: '🧺',
  [SERVICE_TYPES.LOCKSMITH]: '🔑',
  [SERVICE_TYPES.MAKEUP_ARTIST]: '💄',
  [SERVICE_TYPES.MASON]: '🧱',
  [SERVICE_TYPES.MEAL_PREP_SERVICE]: '🥗',
  [SERVICE_TYPES.MECHANIC]: '🔩',
  [SERVICE_TYPES.MOVING_COMPANY]: '🚛',
  [SERVICE_TYPES.NAIL_TECHNICIAN]: '💅',
  [SERVICE_TYPES.NOTARY_PUBLIC]: '📜',
  [SERVICE_TYPES.OTHER]: '📋',
  [SERVICE_TYPES.PAINTER]: '🎨',
  [SERVICE_TYPES.PARTY_RENTALS]: '🎉',
  [SERVICE_TYPES.PASTRY_SHOP]: '🧁',
  [SERVICE_TYPES.PEST_CONTROL]: '🐜',
  [SERVICE_TYPES.PET_GROOMING]: '🐕',
  [SERVICE_TYPES.PET_SITTING]: '🐈',
  [SERVICE_TYPES.PHOTOGRAPHER]: '📷',
  [SERVICE_TYPES.PLUMBER]: '🔧',
  [SERVICE_TYPES.POOL_MAINTENANCE]: '🏊',
  [SERVICE_TYPES.RESTAURANT]: '🍽️',
  [SERVICE_TYPES.SHOE_REPAIR]: '👞',
  [SERVICE_TYPES.SOLAR_INSTALLER]: '☀️',
  [SERVICE_TYPES.SPA_MASSAGE_THERAPIST]: '🧖',
  [SERVICE_TYPES.STORAGE_SERVICES]: '📦',
  [SERVICE_TYPES.TAILOR]: '🧵',
  [SERVICE_TYPES.TILER]: '📐',
  [SERVICE_TYPES.TOUR_GUIDE]: '🗺️',
  [SERVICE_TYPES.TRANSLATION_SERVICES]: '🗣️',
  [SERVICE_TYPES.TRANSPORTATION]: '🚕',
  [SERVICE_TYPES.TUTOR]: '📚',
  [SERVICE_TYPES.VIDEOGRAPHER]: '🎥',
  [SERVICE_TYPES.WEB_DEVELOPER]: '🌐',
  [SERVICE_TYPES.WEDDING_PLANNER]: '💒',
  [SERVICE_TYPES.YOGA_INSTRUCTOR]: '🧘'
};

export const categoryColors = {
  // Alphabetical by service type
  [SERVICE_TYPES.APPLIANCE_REPAIR]: '#607D8B',
  [SERVICE_TYPES.AUTO_BODY_REPAIR]: '#2C3E50',
  [SERVICE_TYPES.BAKERY]: '#F9A825',
  [SERVICE_TYPES.BARBER]: '#9B59B6',
  [SERVICE_TYPES.BEAUTY_SALON]: '#EC407A',
  [SERVICE_TYPES.CAR_WASH_DETAILING]: '#00BCD4',
  [SERVICE_TYPES.CARPENTER]: '#E67E22',
  [SERVICE_TYPES.CATERING]: '#795548',
  [SERVICE_TYPES.CHILDCARE]: '#E91E63',
  [SERVICE_TYPES.CLEANER]: '#F39C12',
  [SERVICE_TYPES.COFFEE_SHOP]: '#6D4C41',
  [SERVICE_TYPES.CONSULTANT]: '#37474F',
  [SERVICE_TYPES.CULINARY_CLASSES]: '#FF8A65',
  [SERVICE_TYPES.DELIVERY_SERVICE]: '#009688',
  [SERVICE_TYPES.DIGITAL_MARKETING]: '#00838F',
  [SERVICE_TYPES.DJ_ENTERTAINMENT]: '#7B1FA2',
  [SERVICE_TYPES.ELDER_CARE]: '#3E2723',
  [SERVICE_TYPES.ELECTRICIAN]: '#FFD700',
  [SERVICE_TYPES.EVENT_PLANNER]: '#AB47BC',
  [SERVICE_TYPES.FITNESS_TRAINER]: '#BF360C',
  [SERVICE_TYPES.FLOORING_SPECIALIST]: '#E67E22',
  [SERVICE_TYPES.FOOD_CATERER]: '#FFAB40',
  [SERVICE_TYPES.FOOD_DELIVERY]: '#4CAF50',
  [SERVICE_TYPES.FOOD_TRUCK]: '#FF9800',
  [SERVICE_TYPES.GRAPHIC_DESIGNER]: '#0097A7',
  [SERVICE_TYPES.HAIRDRESSER]: '#E74C3C',
  [SERVICE_TYPES.HANDYMAN]: '#2C3E50',
  [SERVICE_TYPES.HVAC_TECHNICIAN]: '#1ABC9C',
  [SERVICE_TYPES.ICE_CREAM_PARLOR]: '#CE93D8',
  [SERVICE_TYPES.INTERIOR_DESIGNER]: '#8E44AD',
  [SERVICE_TYPES.IT_SUPPORT]: '#1565C0',
  [SERVICE_TYPES.JEWELRY_REPAIR]: '#FFD700',
  [SERVICE_TYPES.JUICE_BAR]: '#FF6F00',
  [SERVICE_TYPES.LANDSCAPER]: '#27AE60',
  [SERVICE_TYPES.LANGUAGE_INSTRUCTOR]: '#00695C',
  [SERVICE_TYPES.LAUNDRY_SERVICE]: '#2196F3',
  [SERVICE_TYPES.LOCKSMITH]: '#FF9800',
  [SERVICE_TYPES.MAKEUP_ARTIST]: '#E91E63',
  [SERVICE_TYPES.MASON]: '#D35400',
  [SERVICE_TYPES.MEAL_PREP_SERVICE]: '#66BB6A',
  [SERVICE_TYPES.MECHANIC]: '#3498DB',
  [SERVICE_TYPES.MOVING_COMPANY]: '#607D8B',
  [SERVICE_TYPES.NAIL_TECHNICIAN]: '#FF6B6B',
  [SERVICE_TYPES.NOTARY_PUBLIC]: '#4E342E',
  [SERVICE_TYPES.OTHER]: '#95A5A6',
  [SERVICE_TYPES.PAINTER]: '#2ECC71',
  [SERVICE_TYPES.PARTY_RENTALS]: '#FFA726',
  [SERVICE_TYPES.PASTRY_SHOP]: '#F8BBD0',
  [SERVICE_TYPES.PEST_CONTROL]: '#795548',
  [SERVICE_TYPES.PET_GROOMING]: '#5D4037',
  [SERVICE_TYPES.PET_SITTING]: '#4E342E',
  [SERVICE_TYPES.PHOTOGRAPHER]: '#78909C',
  [SERVICE_TYPES.PLUMBER]: '#4A90D9',
  [SERVICE_TYPES.POOL_MAINTENANCE]: '#03A9F4',
  [SERVICE_TYPES.RESTAURANT]: '#FF5722',
  [SERVICE_TYPES.SHOE_REPAIR]: '#795548',
  [SERVICE_TYPES.SOLAR_INSTALLER]: '#F1C40F',
  [SERVICE_TYPES.SPA_MASSAGE_THERAPIST]: '#A8E6CF',
  [SERVICE_TYPES.STORAGE_SERVICES]: '#8D6E63',
  [SERVICE_TYPES.TAILOR]: '#9E9E9E',
  [SERVICE_TYPES.TILER]: '#16A085',
  [SERVICE_TYPES.TOUR_GUIDE]: '#00BCD4',
  [SERVICE_TYPES.TRANSLATION_SERVICES]: '#4A148C',
  [SERVICE_TYPES.TRANSPORTATION]: '#3F51B5',
  [SERVICE_TYPES.TUTOR]: '#2E7D32',
  [SERVICE_TYPES.VIDEOGRAPHER]: '#546E7A',
  [SERVICE_TYPES.WEB_DEVELOPER]: '#0D47A1',
  [SERVICE_TYPES.WEDDING_PLANNER]: '#EC407A',
  [SERVICE_TYPES.YOGA_INSTRUCTOR]: '#4A148C'
};